export class AbhollisteNumberInputDialogResult {
    confirmed = false;
    anzahl_tiere: number;
    in_abholliste_einbeziehen: boolean;
}
